import supportImg0 from '../../assets/cooperation/support-img0.jpg'
import supportImg1 from '../../assets/cooperation/support-img1.png'
import supportImg2 from '../../assets/cooperation/support-img2.jpg'

export default {
  name: 'cooperation',
  data () {
    return {
      supportTitles: [
        {
          id: 0,
          title: '定制服务',
          imgs: ['../../assets/cooperation/support1.png', '../../assets/cooperation/support1-active.png']
        },
        {
          id: 1,
          title: '渠道合作',
          imgs: ['../../assets/cooperation/support3.png', '../../assets/cooperation/support3-active.png']
        },
        {
          id: 2,
          title: 'CRM对接',
          imgs: ['../../assets/cooperation/support2.png', '../../assets/cooperation/support2-active.png']
        }
      ],
      supportList: [
        {
          id: 0,
          title: '定制服务',
          items: ['基于奥创系统，定制个性化系统功能；', '合作开发有价值的新产品，一起推进市场；'],
          'bgImg': supportImg0
        },
        {
          id: 1,
          title: '渠道合作',
          items: ['合作销售奥创现有产品，高返点；', '强大的研发团队保障系统的稳定性，安全性；'],
          'bgImg': supportImg1
        },
        {
          id: 2,
          title: 'CRM对接',
          items: ['提供奥创系统与客户CRM完美打通；', '提供私有化服务器搭建，数据和程序部署；'],
          'bgImg': supportImg2
        }
      ],
      supportIndex: 1,
      screenWidth: 0,
      promptMessage: {
        type: 'default',
        value: ''
      },
      username: '', // 用户名
      companyName: '', // 公司名称
      phoneNumber: '', // 电话号码
      verifyCode: '', // 验证码
      autocomplete: '' // 留言
    }
  },
  created () {
    this.screenWidth = screen.width || document.documentElement.clientWidth
  },
  methods: {
    toggleSupports: function (index) {
      this.supportIndex = index
    },
    /**
     * 获取验证码
     */
    async getVerify () {
      let res = await this.axios.get(`https://api.jarviscoder.com/super/common/verifycode?phone=${this.phoneNumber}`)
      console.log(res)
    },
    // 提交
    async submitApply () {
      let result = await this.submitVerify()
      if (result) {
        let subResult = await this.axios.post('https://api.jarviscoder.com/super/customerintention/insert', {
          CompanyName: this.companyName,
          ContactName: `奥创工作手机官网,姓名:${this.username}`,
          Phone: this.phoneNumber,
          Intention: '试用',
          ProductType: '合作伙伴',
          extra: { 'remark': this.autocomplete, 'companyName': this.companyName }
        }).then(({ data }) => data.Result)
        if (subResult) {
          this.promptMessage = {
            type: 'success',
            value: '您已提交申请,请耐心等待'
          }
        }
      }
    },
    // 提交前验证
    async submitVerify () {
      if (!this.username.trim()) {
        this.promptMessage = {
          type: 'error',
          value: '请填写姓名.'
        }
        return false
      }
      if (!this.companyName.trim()) {
        this.promptMessage = {
          type: 'error',
          value: '请填写公司名.'
        }
        return false
      }
      if (!this.phoneNumber.trim()) {
        this.promptMessage = {
          type: 'error',
          value: '请填手机号.'
        }
        return false
      }
      if (!this.verifyCode.trim()) {
        this.promptMessage = {
          type: 'error',
          value: '请获取,并填写验证码.'
        }
        return false
      }
      if (!this.verifyCode.trim()) {
        this.promptMessage = {
          type: 'error',
          value: '请获取,并填写验证码.'
        }
        return false
      }
      let result = await this.axios.post('https://api.jarviscoder.com/super/common/ValidVerifyCode', { phone: this.phoneNumber, verifyCode: this.verifyCode }).then(({ data }) => data.Result)
      if (!result) {
        this.promptMessage = {
          type: 'error',
          value: '验证码错误.'
        }
        return false
      }
      return result
    }
  }
}
